module.exports = __webpack_public_path__ + "img/linecode.7a85e37d.png";